// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StsConfigHttpLoader } from 'angular-auth-oidc-client';
// Other
import { Store } from '@ngxs/store';
// Model
import { ConfigFileModel, FaroSdkService, LoadConfigFile, LocalStorage, SKIP_AUTH_HEADER } from '@cv-invision/core';
import { environment } from '../../../environments/environment';
// Other
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
/**
 * AuthLoaderFactory for OIDC
 *
 * @param configService ConfigQCService
 * @returns
 */
export const AppLoaderFactory: any = (store: Store, configService: ConfigQCService, faroSdkService: FaroSdkService) => {

	// Get the Config Json and Initialize the Storage with the Basic for the app to run
	const config$: any = configService.loadConfigFile()
		.pipe(
			map((configData: ConfigFileModel) => {
				configService.config = configData;
                configService.isLoadingFile = false;
                configService.initialized = true;
				// Dispatch the Config File
				store.dispatch(new LoadConfigFile(configData.oidc_configuration.clientId, configData));
				// Return Configuration
				const config = configData.oidc_configuration;
				config.storage = new LocalStorage();
				faroSdkService.StartFaroSdk(configData)
				return configData.oidc_configuration;
			})
		).toPromise();

	return new StsConfigHttpLoader(config$);
};

@Injectable()
export class ConfigQCService {
	public config = new ConfigFileModel();
	public isLoadingFile = false;
    public initialized = false;

	configLoader$: Observable<ConfigFileModel> = new Observable();

	get api(): any { return this.config.api; }
	get version(): any { return this.config.version; }
	get ids(): any { return this.config.oidc_configuration; }

	constructor(private http: HttpClient) {
		// silence
	}

	/**
	 * Load configfile
	 *
	 * @returns Observable<ConfigFileModel>
	 */
	loadConfigFile(): Observable<ConfigFileModel> {
		return this.http
			.get<any>(
				environment.configFile,
				{
					headers: {
						[SKIP_AUTH_HEADER]: SKIP_AUTH_HEADER
					}
				}
			);
	}

	/**
	 * Load Versions file
	 *
	 * @returns Observable<ConfigFileModel>
	 */
	loadVersionsFile(): Observable<any> {
		return this.http
			.get<any>(
				environment.versionsFile,
				{
					headers: {
						[SKIP_AUTH_HEADER]: SKIP_AUTH_HEADER
					}
				}
			);
	}

	/**
	 * Get ids config
	 *
	 * @returns Observable<ConfigFileModel>
	 */
	getIdsConfig(): Observable<ConfigFileModel> {
		return of(this.ids);
	}

	/**
	 * Get dependencies
	 *
	 * @returns Observable<any>
	 */
	getDependenciesVersions(enviroment: string): Observable<any> {
		const httpParams = new HttpParams();
		httpParams.append('env', enviroment);

		return this.http.get(`/api/config/versions`, { params: httpParams }).pipe(
			map(payload => {
				return payload;
			})
		);
	}

	/**
	 * Get release notes
	 *
	 * @returns Observable<any>
	 */
	getReleaseNotes(): Observable<any> {
		return this.http.get('/api/config/release-notes').pipe(
			map((payload: any) => {
				return payload.data;
			})
		);
	}
}
